import React from "react";
import { styled, ButtonBase, Theme } from "@material-ui/core";
import { MobileViewmodeType } from "../../../constants";
import useTranslate from "../../../../../hooks/use-translate";
import StoreLocatorListIcon from "../../../../../components/icons/list";
import MapPinIcon from "../../../../../components/icons/map-pin";

const Wrapper = styled("div")({
  display: "flex",
  justifyContent: "space-between",
  width: "100%",
  height: "100%",
  boxShadow: "0px 4px 4px rgba(0, 0, 0, 0.05)",
  minHeight: "35px",
  "& > button": {
    flex: "1 1 auto"
  },
  flex: 1
});

const CustomButton = styled(ButtonBase)(
  ({ theme, isActive }: { theme: Theme; isActive?: boolean }) => ({
    fontFamily: "Roobert",
    borderBottom: isActive
      ? `2px solid ${theme.palette.primary.main}`
      : `2px solid ${theme.palette.grey[300]}`,
    borderRadius: 0,
    fontWeight: isActive ? 600 : 400
  })
);

const CustomGeoPinIcon = styled(MapPinIcon)(() => ({
  marginRight: "6px"
}));

const CustomListIcon = styled(StoreLocatorListIcon)(() => ({
  marginRight: "6px"
}));

type Props = {
  value: MobileViewmodeType;
  onChange: (MobileViewmodeType) => void;
};

const MobileViewmodeSwitcher = ({ value, onChange }: Props) => {
  const t = useTranslate();
  return (
    <Wrapper>
      <CustomButton
        onClick={() => onChange("list")}
        isActive={value === "list"}
      >
        <CustomListIcon />
        {t("storeLocator.list")}
      </CustomButton>
      <CustomButton onClick={() => onChange("map")} isActive={value === "map"}>
        <CustomGeoPinIcon />
        {t("storeLocator.map")}
      </CustomButton>
    </Wrapper>
  );
};

export default MobileViewmodeSwitcher;
